export function isPrimitive(value: any): boolean {
  if (value === null) {
    return true;
  }
  const type = typeof value;
  return type !== 'object' && type !== 'function';
}